import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sis_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(detail, fallback = "Ocurrió un error. Intente de nuevo.") {
  const d = detail?.response?.data?.detail ?? detail;
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return fallback;
}

export async function facturaBlobUrl(facturaId) {
  const { data } = await api.get(`/facturas/${facturaId}/pdf`, { responseType: "blob" });
  return URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
}

export async function contratoBlobUrl(estudianteId) {
  const { data } = await api.get(`/estudiantes/${estudianteId}/contrato/pdf`, { responseType: "blob" });
  return URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
}

export async function descargarContratoPdf(estudianteId, nombre = "contrato.pdf") {
  const url = await contratoBlobUrl(estudianteId);
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export async function descargarFacturaPdf(facturaId, ncf) {
  const url = await facturaBlobUrl(facturaId);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Factura-${ncf}.pdf`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export async function descargarBoletinFamilia(nombre = "Boletin-familia.pdf") {
  const { data } = await api.get("/portal/boletin-familia/pdf", { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export async function descargarPdf(path, params, nombre) {
  const { data } = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export async function descargarExcel(path, params, nombre) {
  const { data } = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(new Blob([data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  }));
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
